import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { PhysicianNotificationQuestionnaireItem } from './questionnaire'

export const PHYSICIAN_NOTIFICATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_TEMP_GREATER]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_TEMP_LESS]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_PULSE_GREATER]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_PULSE_LESS]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_RESPIRATIONS_GREATER]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_RESPIRATIONS_LESS]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_BP_GREATER]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_BP_LESS]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_WEIGHT_GREATER]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_WEIGHT_LESS]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_ETCO2_SATURATION_GREATER]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_ETCO2_SATURATION_LESS]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_O2_SATURATION_GREATER]:
    QuestionnaireAnswerType.STRING,
  [PhysicianNotificationQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_O2_SATURATION_LESS]:
    QuestionnaireAnswerType.STRING
}
